import React, { useState } from 'react';
import { CommissionDashboard } from './components/CommissionDashboard';
import { UserRole, Commission } from './types/commission';
import { MOCK_COMMISSIONS } from './data/mockData';
export function App() {
  const [currentRole, setCurrentRole] = useState<UserRole>('Loan Officer');
  const [commissions, setCommissions] = useState<Commission[]>(MOCK_COMMISSIONS);
  return <div className="h-full" data-id="element-0">
      <CommissionDashboard currentRole={currentRole} onRoleChange={setCurrentRole} commissions={commissions} onUpdateCommissions={setCommissions} data-id="element-1" />
    </div>;
}